<h4 mat-dialog-title><i class="fas fa-plus mr-1"></i> Update Geofence</h4>

<mat-dialog-content class="mat-typography">
    <div>
        <form class="example-form input-content" [formGroup]="form">
            <!-- <mat-form-field class="example-full-width">
                <mat-label>Geofence ID</mat-label>
                <input type="text" matInput formControlName="geofenceId">
            </mat-form-field> -->

            <mat-form-field class="example-full-width">
                <mat-label>Geofence Name</mat-label>
                <input type="text" matInput formControlName="geofenceName" maxlength="30">
            </mat-form-field>

            <mat-form-field class="example-full-width">
                <mat-label>Geofence Description</mat-label>
                <input type="text" matInput formControlName="geofenceDesc">
            </mat-form-field>

            <!-- <mat-form-field class="example-full-width" appearance="fill">
                <mat-label>Zone</mat-label>
                <mat-select formControlName="zone" [(ngModel)]="dropZoneData" multiple>
                  <mat-option *ngFor="let zoneObject of zoneData" [value]="zoneObject.zoneId">{{zoneObject.zoneName}} - {{zoneObject.zoneId}}</mat-option>
                </mat-select>
            </mat-form-field> -->

            <div class="float-left">
                <mat-label>Is Active:</mat-label>
            </div>
            <div class="float-left ml-2" style="margin-top: 0.15rem;">
                <input type="checkbox" formControlName="status" [(ngModel)]="isStatus">
            </div>
        </form>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button class="btn btn-success float-right mr-2" type="submit" (click)="updateGeofenceData()">
        <i class="fas fa-plus mr-1"></i> Update</button>
    <button class="btn btn-light float-right" (click)="closeDialog()">
        <i class="fas fa-times mr-1"></i> Cancel</button>
</mat-dialog-actions>